import Icon from '../components/Icon.vue'

Icon.register({
  'hand-scissors': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 440c0-22.1 17.9-40 40-40v-8h-32c-22.1 0-40-17.9-40-40s17.9-40 40-40h32v-8h-208c-26.5 0-48-21.5-48-48s21.5-48 48-48h208v-13.6l-177.6-69.7c-24.7-9.7-36.8-37.6-27.1-62.2 9.7-24.7 37.6-36.8 62.2-27.1l190.3 74.8 24.9-31.1c12.3-15.4 34-19.5 51.1-9.7l112 64c11.1 6.4 20.2 21.9 20.2 34.7v240c0 18.6-12.8 34.7-30.8 38.9l-136 32c-2.5 0.6-6.6 1.1-9.2 1.1h0-80c-22.1 0-40-17.9-40-40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-scissors.js
// module id = 1437
// module chunks = 0